module.exports = __webpack_public_path__ + "static/11-29ff8e5183a8101361b6098a9db71133.png";